import React from "react";
import { useHistory } from "react-router-dom";
import { injectIntl } from 'react-intl';
import {IconButton } from "@mui/material";
import {COMMON_UTIL} from "@/common/util/common.util"; 
import {Root, LogoSection} from "./Styled/HeaderStyled";
import {inject, observer} from "mobx-react";
import Logo from "@/common/Images/Logo.svg";
import { Icon } from "@iconify/react";
import { useToast } from "@/components/useToast";

function Header(props) {
  const {intl } = props;
  const history = useHistory();
  const { showDeleteToast } = useToast();

  // TODO app에서만 사용
  const handleSetting = () => {
    if (COMMON_UTIL.isWebView()) {
      history.push("/setting");
    } else {
      showDeleteToast("App에서만 사용 가능한 기능입니다");
    }
  };
  return (
    <Root>
      <LogoSection>
        <img
          src={Logo}
          alt="logo"
          style={{ height: "19px" }}
        />
      </LogoSection>
      <IconButton color="inherit" onClick={handleSetting}>
        <Icon icon="ion:settings-outline" style={{ fontSize: "24px" }}/> 
      </IconButton>
    </Root>
  );
}

export default injectIntl(inject('authStore', 'userStore', 'homeStore', 'modalStore', 'pronunciationStore', 'reportStore')(observer(Header)));
